export const environment = {
    production: true,
    stage: 'dev',
    backendUrl: process.env.REACT_APP_BACKEND_URL ?? 'https://dev.backend.modernmedicus.pl/api',
};
